"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormActionsEnum = exports.SubmitStatusTypeEnum = exports.FormTypeEnum = void 0;
var FormTypeEnum;
(function (FormTypeEnum) {
    FormTypeEnum[FormTypeEnum["NA"] = 0] = "NA";
    FormTypeEnum[FormTypeEnum["Pardot"] = 1] = "Pardot";
    FormTypeEnum[FormTypeEnum["ServiceCloud"] = 2] = "ServiceCloud";
    FormTypeEnum[FormTypeEnum["Distributors"] = 3] = "Distributors";
    FormTypeEnum[FormTypeEnum["DpsDistributors"] = 4] = "DpsDistributors";
    FormTypeEnum[FormTypeEnum["Custom"] = 5] = "Custom";
})(FormTypeEnum || (exports.FormTypeEnum = FormTypeEnum = {}));
var SubmitStatusTypeEnum;
(function (SubmitStatusTypeEnum) {
    SubmitStatusTypeEnum[SubmitStatusTypeEnum["Submitted"] = 0] = "Submitted";
    SubmitStatusTypeEnum[SubmitStatusTypeEnum["ServerError"] = 1] = "ServerError";
    SubmitStatusTypeEnum[SubmitStatusTypeEnum["ValidationError"] = 2] = "ValidationError";
    SubmitStatusTypeEnum[SubmitStatusTypeEnum["IsProcessing"] = 3] = "IsProcessing";
})(SubmitStatusTypeEnum || (exports.SubmitStatusTypeEnum = SubmitStatusTypeEnum = {}));
var FormActionsEnum;
(function (FormActionsEnum) {
    FormActionsEnum[FormActionsEnum["Submit"] = 0] = "Submit";
    FormActionsEnum[FormActionsEnum["FormControlValueChange"] = 1] = "FormControlValueChange";
})(FormActionsEnum || (exports.FormActionsEnum = FormActionsEnum = {}));
